import { z } from 'zod';

export enum ValidationType {
    CREATION = 'CREATION',
    UPDATE = 'UPDATE',
    DELETE = 'DELETE',
}

export const ValidationTypeSchema = z.enum(ValidationType);
